import styled from "styled-components"
import { colors } from "styles/global-styles";

interface IconProps {
    text: string;
    type: string;
}
interface TooltipIconProps {
    content: string;
}
const RoundIconStyle = styled.span<{type: string}>`
    display: inline-block;
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
    background-color: ${({ theme, type }) => {
        if (type === 'disabled') return theme.newTheme.icon.disabledBg;
        if (type === 'primary') return theme.newTheme.icon.primaryBg;
        if (type === 'success') return theme.newTheme.icon.successBg;
        if (type === 'waiting') return theme.newTheme.icon.yellowBg;
        if (type === 'orange') return colors.vermillion;
        if (type === 'green') return colors.green;
        if (type === 'blue') return colors.blue;
        if (type === 'yellow') return colors.yellow;
        return theme.newTheme.icon.defaultBg;
    }};
    color: ${({ theme, type }) => {
        if (type === 'disabled') return theme.newTheme.icon.disabledText;
        return theme.newTheme.icon.defaultText;
    }};
`;

const TooltipIconStyle = styled.span`
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    cursor: pointer;
    background-color: ${({ theme }) => theme.newTheme.icon.disabledBg};
    position: relative;
    span {
        min-width: 22rem;
        visibility: hidden;
        position: absolute;
        top: -1.5rem;
        left: 0;
        background-color: ${({ theme }) => theme.newTheme.icon.defaultBg};
        color: ${({ theme }) => theme.newTheme.icon.defaultText};
        padding: 0.25rem 0.5rem;
        border-radius: 0.25rem;
        z-index: 2;
        &::after {
            content: '';
            position: absolute;
            bottom: -1rem;
            border-top: 10px solid ${({ theme }) => theme.newTheme.icon.defaultBg};
            color: #FFFFFF;
            left: -1px;
            border-radius: 0.5rem;
            width: 0;
            height: 0;
            border-bottom: 10px solid transparent;
            border-left: 10px solid transparent;
            border-right: 10px solid transparent;
        }
    }
    &:hover span {
        visibility: visible;
    }
`;

// text만 있는 round 배경 아이콘
export function RoundIcon({text, type}: IconProps) {
    return (
        <RoundIconStyle type={type}>{text}</RoundIconStyle>
    )
}

// tooltip
export function TooltipIcon({content} : TooltipIconProps) {
    return (
        <TooltipIconStyle>!
            <span>{content}</span>
        </TooltipIconStyle>
    )
}